import NavMenuLayout from "component/layout/NavMenuLayout";
import FooterLayout from "component/layout/FooterLayout";
import PageRoute from "./PageRoute";


/**
 * 各个页面路由的注册信息，其中的层次结构仅为url的层级设计，与导航菜单的层次无关
 */
const routers: PageRoute[] = [
    {
        key: 'index',
        component: './pages/Home',
        title : '主页',
        path : '/',
        layout: {
            layout: NavMenuLayout,
            props: {
                outletStyle: false,
                breadcrumb : false,
                footer: false
            }
        }
    },
    {
        key: 'login',
        component: './pages/Login',
        title : '登录',
        path : '/login',
        auth: false,
    },
    {
        key: 'query',
        title: "数据查询",
        path : '/query',
        layout: NavMenuLayout,
        children: [
            {
                key: 'queryLabelBoards',
                component: './pages/QueryLabelBoards',
                title: '标注板查询',
                path: 'query_label_boards'
            },
            {
                key: 'queryAdmissionRecords',
                component: './pages/QueryAdmissionRecords',
                title: '临床信息查询',
                path: 'query_admission_records'
            }
        ]
    },
    {
        key: 'basic',
        title: "工作台",
        path : '/workbench',
        layout: NavMenuLayout,
        children: [
            {
                key: 'labelingMgmt',
                component: './pages/EfmLabelingMgmt',
                title: '标注任务管理',
                path: 'labeling_mgmt'
            },
            {
                key: 'labelingBoard',
                component: './pages/EfmLabelingBoard',
                title: '标注板',
                path: 'labelingBoard'
            },
            {
                key: 'labelingDiff',
                component: './pages/EfmLabelingDiff',
                title: '标注方案对比',
                path: 'labelingDiff'
            },
            {   
                key: 'workbench',
                component: './pages/Workbench',
                title : '标注人工作台',
                path: "workbench"
            },
            {   
                key: 'workbenchOfReviewer',
                component: './pages/WorkbenchOfReviewer',
                title : '协同人工作台',
                path: "workbenchOfReviewer"
            },
            {
                key: 'workloadStats',
                component: './pages/WorkloadStats',
                title: '工作量统计',
                path: 'workload_stats'
            }  
        ]
    },
    {
        key: 'projectManagement',
        title: "科研项目管理",
        path: '/project',
        layout: NavMenuLayout,
        children: [
            {
                key: 'researchProject',
                component: './pages/EfmResearchProject',
                title: '科研项目设置',
                path: 'researchProject'
            },
            {
                key: 'researchProjectMember',
                component: './pages/EfmResearchProjectMembers',
                title: '科研项目成员管理',
                path: 'researchProjectMember'
            },
            {
                key: 'dataGroupAndLabelScheme',
                component: './pages/EfmDataGroupAndLabelScheme',
                title: '数据分组和标注方案设置',
                path: 'dataGroupAndLabelScheme'
            },
            {
                key: 'dataGroup',
                component: './pages/EfmDataGroup',
                title: '数据分组设置',
                path: 'dataGroup'
            },
            {
                key: 'labelingScheme',
                component: './pages/EfmLabelingScheme',
                title: '标注方案设置',
                path: 'labelingScheme'
            },
            {
                key: 'researchDataImportFromFCIS',
                component: './pages/ResearchDataImportFromFCIS',
                title: '导入FCIS数据到科研项目',
                path: 'researchDataImportFromFCIS'
            },
            {
                key: 'researchDataImportFromDataset',
                component: './pages/ResearchDataImportFromDataset',
                title: '导入第三方数据集到科研项目',
                path: 'researchDataImportFromDataset'
            },
            {
                key: 'researchDataMgmt',
                component: './pages/ResearchDataMgmt',
                title: '科研数据管理',
                path: 'researchDataMgmt'
            },
            {
                key: 'assignLabelingTask',
                component: './pages/AssignLabelingTask',
                title: '指派标注任务',
                path: 'assign_labeling_task'
            }
        ]
    },
    {
        key: 'repositoryManagement',
        title: "样例素材库管理",
        path: '/repository',
        layout: NavMenuLayout,
        children: [
            {
                key: 'materialRepository',
                component: './pages/MaterialRepository',
                title: '样例素材库设置',
                path: 'materialRepository'
            },
            {
                key: 'materialRepositoryMember',
                component: './pages/MaterialRepositoryMembers',
                title: '样例素材库成员管理',
                path: 'materialRepositoryMember'
            },
            {
                key: 'materialDataMgmt',
                component: './pages/MaterialDataMgmt',
                title: '样例素材数据管理',
                path: 'materialDataMgmt'
            },
            {
                key: 'addEfmSlicesToMaterialRepository',
                component: './pages/AddEfmSlicesToMaterialRepository',
                title: '导入EFM底板到样例素材库',
                path: 'addEfmSlicesToMaterialRepository'
            },
            {
                key: 'editMaterialDraft',
                component: './pages/EditMaterialDraft',
                title: '编辑素材草稿',
                path: 'editMaterialDraft'
            },
            {
                key: 'materialDetails',
                component: './pages/MaterialDetails',
                title: '编辑素材',
                path: 'materialDetails'
            }
        ]
    },
    {
        key: 'taskPhotos',
        title: "随手拍",
        path: '/task_photos',
        layout: NavMenuLayout,
        children: [
            {
                key: 'takePhotos',
                component: './pages/TakePhotos',
                title: '随手拍管理',
                path: 'takePhotos'
            }
        ]
    },
    {
        key: 'settings',
        title: "系统管理",
        path: "/settings",
        layout: NavMenuLayout,
        children: [
            {
                key: 'users',
                component: './pages/Users',
                title: '用户管理',
                path: 'users'
            },
            {
                key: 'adminManageResearchProject',
                component: './pages/AdminManageResearchProject',
                title: '科研项目管理',
                path: 'projects'
            },
            {
                key: 'adminManageMaterialRepository',
                component: './pages/AdminManageMaterialRepository',
                title: '样例素材库管理',
                path: 'materialRepositories'
            },
            {
                key: 'manageGlobalEfmData',
                component: './pages/ManageGlobalEfmData',
                title: '全局EFM数据管理',
                path: 'manageGlobalEfmData'
            }
        ]
    }, 
    {
        key: 'mobile',
        title: '', 
        path: '/mobile',
        layout: FooterLayout,
        children: [
            {
                key: 'mobileLogin',
                component: './pages/MobileLogin',
                title: '登录',
                path: 'login',
                auth: false
            },
            {
                key: 'mobileAuth',
                component: './pages/MobileAuth',
                title: '认证',
                path: 'auth'
            },
            {
                key: 'mobileRegister',
                component: './pages/MobileRegister',
                title: '注册',
                path: 'register',
                auth: false
            },
            {
                key: 'mobileSubmitPhoto',
                component: './pages/MobileSubmitPhoto',
                title: '随手拍',
                path: 'submit_photo'
            },
            {
                key: 'takePhotoHistory',
                component : "./pages/TakePhotoHistory",
                title: '随手拍历史记录',
                path: 'take_photo_history'
            }
        ]
    }
];


const map: Map<string, { title: string, path: string, auth: boolean }> = new Map();
const parentPath: Array<string> = [];

const readChildrenRoutes = (pages: PageRoute[]) => {
    pages.forEach(p => {
        if (p.children && p.children.length) {
            parentPath.push(p.path);
            readChildrenRoutes(p.children);
        } else {
            let path = parentPath.join('/') + '/' + p.path;
            path = path.replaceAll(/\/+/g, '/');
            map.set(p.key, {path, title: p.title, auth: p.auth !== false});
        }
    })
    if (parentPath.length) {
        parentPath.pop();
    }
}
readChildrenRoutes(routers);

const getPage: (routeKey: string) => { title: string, path: string, auth: boolean, requiredRole?: string } = routeKey => {
    const page = map.get(routeKey);
    if (page) {
        return page;
    } else {
        console.log("cannot found route for key '" + routeKey + "', fallback to /")
        return {path: "/", title: "主页", auth: true, requiredRole: null};
    }

}


const getAllPages: () => { title: string, path: string, auth: boolean }[] = () => {
    return Array.from(map.values());
}

export {routers, getPage, getAllPages};